export const PULL_INTERVAL = 3000;
